<div
	class="request-page-container"
	[ngClass]="{ hideScroll: isTabContentContainerFixed }"
	*ngIf="
		!isRequestPageLoading && !isAvailableCiLoading && !isLoadingAllStatus && !isLoadingAllowedMimeTypes && !isLoadingAvailableTemplates
	">
	<header>
		<msp-breadcrumb-navigation
			[breadcrumb]="[
				{ route: ['/request'], label: labels.lbl_geral_inicio },
				{ route: ['/request', requestData.id], label: labels.lbl_chamado + ' ' + requestData.id },
			]">
		</msp-breadcrumb-navigation>
	</header>
	<section class="request-content">
		<div class="content-container" [ngStyle]="{ width: ghostResizeBar.contentContainer + '%' }">
			<div class="indicator-container">
				<div
					class="indicator success"
					[ngClass]="{
						warning: requestData && requestData.status && requestData.status.toString().toLowerCase().includes('waiting'),
						danger: requestData.status === 'Cancelled',
						link:
							(requestData && requestData.status && requestData.status.toString().toLowerCase().includes('closed')) ||
							requestData.status === 'Solved',
					}">
					<span>{{ labels.lbl_geral_status }}</span>
					<span>{{ allStatusAsLabel[requestData.status] ? allStatusAsLabel[requestData.status] : requestData.status }}</span>
				</div>

				<div
					class="indicator success"
					[ngClass]="{
						danger: formatSecondsToHour(requestData.sla_remaining) === '00h00m',
						link:
							(requestData && requestData.status && requestData.status.toString().toLowerCase().includes('closed')) ||
							requestData.status === 'Solved',
					}"
					*ngIf="!permissionService.hasPermission('REQUEST_hide_SLA') && this.requestData.change_type <= '2'">
					<span>{{ labels.lbl_geral_tempo_restante_sla }}</span>
					<span>{{ formatSecondsToHour(requestData.sla_remaining) }}</span>
				</div>

				<div class="indicator" *ngIf="!permissionService.hasPermission('REQUEST_hide_duration')">
					<span>{{ labels.lbl_geral_duracao }}</span>
					<span>{{ formatMinutesToHour(requestData.duration) }}</span>
				</div>

				<div class="indicator danger" *ngIf="requestData.high_severity == true">
					{{ labels.lbl_chamado_severidade_alta }}
				</div>
			</div>

			<div class="title-request-id">
				<span class="mr-2">{{ labels.lbl_chamado }} {{ requestData.id }}</span>
			</div>

			<div class="title-buttons" *ngIf="requestData.status !== 'Cancelled' && requestData.status !== 'Solved'">
				<button (click)="resetRequest(); isRequestBeingEdited = false" *ngIf="isRequestBeingEdited">
					{{ labels.lbl_geral_cancelar }}
				</button>
				<button
					[ngClass]="{ disabled: this.isSavingLoading || (this.isRequestBeingEdited && !this.isClassificationFulfilled) }"
					(click)="isRequestBeingEdited ? saveRequestChanges() : (this.isRequestBeingEdited = !this.isRequestBeingEdited)"
					*ngIf="userView === userViewTypes.ANALYST && requestData.active === '1'">
					{{ isRequestBeingEdited ? labels.lbl_geral_salvar : labels.lbl_geral_editar_informacoes }}
					<cpi-dot-bounce-loading-effect
						[color]="'var(--const-white)'"
						*ngIf="isRequestBeingEdited && isSavingLoading"></cpi-dot-bounce-loading-effect>
				</button>
				<button
					(click)="cancelRequestModal.openModal()"
					*ngIf="userView === userViewTypes.ANALYST && (!requestDataMemory.id_topic || requestDataMemory.id_topic === '')">
					{{ labels.lbl_geral_cancelar_chamado }}
				</button>
			</div>

			<div class="input-content-container">
				<div class="content-col mt-2 mb-1">
					<div *ngIf="!shouldHideField('registeredBy')">
						<span>{{ labels.lbl_geral_registrado_por }}</span>
						<input type="text" disabled [value]="requestData.registered_by" />
					</div>
					<div *ngIf="!shouldHideField('first_classified_by')">
						<span>{{ labels.lbl_classificado_por }}</span>
						<input type="text" disabled [value]="requestData.first_classified_by" />
					</div>
					<div *ngIf="!shouldHideField('location')">
						<span>{{ labels.lbl_geral_localidade }}</span>
						<input type="text" disabled [value]="requestData.site + ' - ' + requestData.location" />
					</div>
					<div *ngIf="!shouldHideField('affectedLocation') && (isEnduserView || !isRequestBeingEdited)">
						<span>{{ labels.lbl_localidade_afetada }}</span>
						<input type="text" disabled [value]="requestData.affected_location" />
					</div>

					<div
						class="dotted-input-container"
						*ngIf="isRequestBeingEdited && !shouldHideField('affectedLocation') && isAnalystView">
						<span>{{ labels.lbl_localidade_afetada }}</span>
						<select [(ngModel)]="requestData.idAffectedLocation">
							<option value="" disabled>{{ labels.lbl_geral_selecione }}</option>
							<option *ngFor="let opt of affectedLocations" [value]="opt.value">
								{{ opt.label }}
							</option>
						</select>
					</div>

					<div *ngIf="!shouldHideField('openingDate')">
						<span>{{ labels.lbl_chamado_data_abertura }}</span>
						<input type="text" disabled [value]="dateService.formatDate(requestData.open_date)" />
					</div>
					<div *ngIf="!shouldHideField('deadline')">
						<span>{{ labels.lbl_data_limite }}</span>
						<input type="text" disabled [value]="dateService.formatDate(requestData.limit_date)" />
					</div>
					<div *ngIf="!shouldHideField('classificationDate')">
						<span>{{ labels.lbl_chamado_data_classificacao }}</span>
						<input
							type="text"
							disabled
							[value]="requestData.classification_date ? dateService.formatDate(requestData.classification_date) : 'N/A'" />
					</div>
					<div *ngIf="(threeStrikes === 1 || threeStrikes === 2) && requestData.count_strikes !== '0'">
						<span>{{ labels.lbl_strike_atual }}</span
						><input
							type="text"
							[value]="getOrdinalNumber(requestData.count_strikes) + ' - ' + dateService.formatDate(requestData.last_strike)"
							disabled />
					</div>
					<div *ngIf="!shouldHideField('requestFather')">
						<span>{{ labels.lbl_chamado_pai }}</span>
						<input
							[ngClass]="{
								link: requestData.parent_request.id && requestData.parent_request.id != '-1' && !isRequestBeingEdited,
							}"
							type="text"
							[attr.readonly]="!isRequestBeingEdited ? true : null"
							[value]="
								(requestData.parent_request.id && requestData.parent_request.id != '-1') || isRequestBeingEdited
									? requestData.parent_request.id
									: requestData.parent_request.id === '-1'
										? labels.lbl_chamado_nao_encontrado
										: 'N/A'
							"
							(click)="
								!isRequestBeingEdited &&
								requestData.parent_request &&
								requestData.parent_request.id !== '' &&
								requestData.parent_request.id != '-1'
									? windowTo('/request/' + requestData.parent_request.id)
									: null
							"
							(input)="requestData.parent_request.id = $event.target.value" />
					</div>
					<div *ngIf="isRequestBeingEdited && confidentialCanEdit" class="driver">
						<span>{{ labels.lbl_geral_chamado_confidencial }}</span>
						<cpi-checkbox
							[value]="requestData.confidential"
							(oValue)="requestData.confidential = $event"
							[innerText]="requestData.confidential == 1 ? labels.lbl_geral_sim : labels.lbl_geral_nao">
						</cpi-checkbox>
					</div>
					<div *ngIf="requestData.confidential == 1 && isRequestBeingEdited">
						<cpi-generic-form-gen [setGenericForm]="[customConfidentialForm]" [labels]="labels"> </cpi-generic-form-gen>
					</div>
					<div *ngIf="!isRequestBeingEdited || !confidentialCanEdit" class="driver">
						<span>{{ labels.lbl_geral_chamado_confidencial }}</span
						><input
							type="text"
							disabled
							[value]="requestData.confidential === '1' ? labels.lbl_geral_sim : labels.lbl_geral_nao" />
					</div>
				</div>

				<div *ngIf="!shouldHideField('summary')" class="description">
					<span class="label">{{ labels.lbl_geral_summary }}: </span>
				</div>
				<div *ngIf="!shouldHideField('summary')" class="description mt-1">
					<input
						type="text"
						[attr.disabled]="isWaitingForApproval || !isRequestBeingEdited ? true : null"
						[value]="requestData.summary"
						(input)="requestData.summary = $event.target.value" />
				</div>

				<div *ngIf="!shouldHideField('description')" class="description mt-2">
					<span class="label">{{ labels.lbl_geral_descricao }}<span *ngIf="isDescriptionRequired">*</span></span>
				</div>
				<div *ngIf="!shouldHideField('description')" class="description mt-1 mb-2">
					<textarea
						[ngStyle]="{ 'min-height': '12em', 'overflow-y': 'auto', resize: 'vertical' }"
						[attr.disabled]="isWaitingForApproval || !isRequestBeingEdited ? true : null"
						(input)="requestData.description = $event.target.value"
						[value]="requestData.description | deNLize | deHTMLLize"
						#descriptionTextarea>
					</textarea>
				</div>

				<div *ngIf="!shouldHideField('additionalNotes')" class="content-col mt-2 mb-1">
					<div>
						<span>{{ labels.lbl_geral_notas_adicionais }}</span> <input type="text" disabled [value]="requestData.notes" />
					</div>
				</div>

				<div class="content-col-header active no-collapse" #classificationHeader>
					<span>{{ labels.lbl_chamado_classificacao }}</span>
				</div>
				<div class="content-col classification static">
					<ng-container
						*ngIf="
							(!requestData.service_type || (requestData.service_type && requestData.service_type.trim() === '')) &&
							!isRequestBeingEdited
						">
						<div>{{ labels.lbl_chamado_nao_classificado }}</div>
					</ng-container>

					<ng-container *ngIf="isRequestBeingEdited">
						<div class="mt-2">
							<cpi-input-with-autocomplete
								[availableOptions]="availableTemplateIAC"
								[minInputLength]="0"
								[placeholder]="labels.lbl_template_chamado"
								(onValueChange)="$event !== '' ? setTemplate($event) : resetRequest()"
								*ngIf="availableTemplateIAC.length > 0">
							</cpi-input-with-autocomplete>
						</div>

						<div class="mt-2">
							<!-- <pcp-request-classification
                        [options]="classificationOptions"
                        [initialIdServicetype]="availableServiceTypes.indexOf(requestData.service_type).toString()"
                        [initialIdScope]="requestData.id_scope"
                        [initialIdCategory]="requestData.id_category"
                        [initialIdTopic]="requestData.id_topic"
                        [initialIdSolutionArea]="requestData.id_solution_area"
                        [initialIdSeverity]="requestData.id_severity"
                        (getClassification)="setClassification($event)">
                        </pcp-request-classification> -->

							<!---
                        <pcp-request-classification-reverse
                        [initOn]="classificationOptions.initOn"
                        [isEditingClassification]="classificationOptions.isEditingClassification"
                        [hideField]="classificationOptions.hideField"
                        [alertField]="classificationOptions.alertField"
                        [lockField]="classificationOptions.lockField"
                        [customerList]="classificationOptions.selectedCustomer"
                        [resetWhenBacktrack]="false"

                        [setIdServicetype]="availableServiceTypes.indexOf(requestData.service_type).toString()"
                        [setIdScope]="requestData.id_scope"
                        [setIdCategory]="requestData.id_category"
                        [setIdTopic]="requestData.id_topic"
                        [setIdSolutionArea]="requestData.id_solution_area"
                        [setIdImpact]="requestData.impact"
                        [setIdUrgency]="requestData.urgency"
                        [setIdSeverity]="requestData.severity"

                        (getClassification)="setClassification($event)"
                        (wasClassificationEditedAfterLoad)="isRequestBeingReclassified = $event"
                        (isLoadingNextStep)="isClassificationLoading = $event"
                        (isClassificationFulfilled)="isClassificationFulfilled = $event">
                        </pcp-request-classification-reverse>
                        --->

							<pcp-request-classification-reverse-rmk
								[setClassificationId]="classificationIds"
								[hideField]="classificationOptions.hideField"
								[alertField]="classificationOptions.alertField"
								[lockField]="classificationOptions.lockField"
								[idCustomerList]="classificationOptions.selectedCustomer"
								(getClassification)="setClassification($event)"
								(wasClassificationEditedAfterLoad)="isRequestBeingReclassified = $event"
								(isLoadingClassification)="isClassificationLoading = $event"
								(isClassificationFulfilled)="isClassificationFulfilled = $event">
							</pcp-request-classification-reverse-rmk>
						</div>

						<div class="mt-2" *ngIf="this.requestData.service_type === 'Change'">
							<span>{{ labels.lbl_geral_tipo_de_risco }}</span>
							<select (change)="requestData.riskType = $event.target.value" [(ngModel)]="requestData.riskType">
								<option [value]="''">{{ labels.lbl_geral_selecione }}</option>
								<option [value]="'0'">Normal</option>
								<option [value]="'1'">Fast</option>
								<option [value]="'2'">Emergencial</option>
							</select>
						</div>

						<div class="mt-2" *ngIf="canSetDriver">
							<div class="dotted-input-container">
								<span>{{ labels.lbl_mudar_para_driver }}</span>
								<cpi-checkbox
									[value]="changeAnalystToDriver"
									(oValue)="changeAnalystToDriver = $event === 1"
									[innerText]="changeAnalystToDriver ? labels.lbl_geral_sim : labels.lbl_geral_nao">
								</cpi-checkbox>
							</div>
						</div>
						<textarea
							*ngIf="isRequestBeingReclassified && requestDataMemory.id_solution_area !== ''"
							[rows]="3"
							[placeholder]="labels.lbl_motivo_reclassificacao + ' *'"
							(input)="reclassifyReason = $event.target.value"></textarea>
					</ng-container>

					<ng-container
						*ngIf="
							!isRequestBeingReclassified &&
							!isRequestBeingEdited &&
							requestData.service_type &&
							requestData.service_type.trim() !== ''
						">
						<div *ngIf="userView === userViewTypes.ANALYST && !shouldHideField('typeService')">
							<span>{{ labels.lbl_chamado_tipo_servico }}</span>
							<input [title]="requestData.service_type" type="text" disabled [value]="requestData.service_type" />
						</div>
						<div *ngIf="userView === userViewTypes.ANALYST && !shouldHideField('scope')">
							<span>{{ labels.lbl_geral_competencia }}</span>
							<input [title]="requestData.scope" type="text" disabled [value]="requestData.scope" />
						</div>
						<div *ngIf="userView === userViewTypes.ANALYST && !shouldHideField('category')">
							<span>{{ labels.lbl_asset_category }}</span>
							<input [title]="requestData.category" type="text" disabled [value]="requestData.category" />
						</div>
						<div *ngIf="userView === userViewTypes.ANALYST && !shouldHideField('topic')">
							<span>{{ labels.lbl_geral_topico }} </span>
							<input
								[title]="requestData.topic"
								type="text"
								disabled
								[value]="(requestData.change_type <= '2' ? 'Standard - ' : 'Non-Standard - ') + requestData.topic" />
						</div>
						<div *ngIf="!shouldHideField('group')">
							<span>{{ labels.lbl_geral_grupo }}</span>
							<input [title]="requestData.solution_area" type="text" disabled [value]="requestData.solution_area" />
						</div>
						<div
							*ngIf="
								(userView === userViewTypes.ANALYST &&
									!shouldHideField('severity') &&
									(this.requestData.id_service_type?.toString() == '1' ||
										this.requestData.id_service_type?.toString() == '2') &&
									requestData.severity != undefined &&
									requestData.severity?.toString() !== '' &&
									requestData.severity?.toString() != '-1' &&
									requestData.service_type === 'Incident') ||
								requestData.service_type === 'Problem'
							">
							<span>{{ labels.lbl_geral_severidade }}</span>
							<input
								[title]="requestData.severity"
								type="text"
								disabled
								[value]="requestData.severity ? requestData.severity : '1'" />
						</div>
						<div
							*ngIf="
								requestData.service_type === 'Change' && userView === userViewTypes.ANALYST && !shouldHideField('riskType')
							">
							<span>{{ labels.lbl_geral_tipo_de_risco }}</span>
							<input [title]="requestData.riskType" type="text" disabled [value]="getRiskType(requestData.riskType)" />
						</div>
					</ng-container>
				</div>

				<!--- Plano de Mudança --->
				<ng-container
					*ngIf="
						this.requestData.changePlan && this.requestData.changePlan.length > 0 && this.requestData.service_type === 'Change'
					">
					<div class="content-col-header active no-collapse" #horariosChangeCollapsable>
						<span>{{ labels.lbl_geral_plano_mudanca }}</span>
					</div>

					<div class="content-col content-change">
						<!-- Tempo Total da Mudança -->
						<div class="mt-2" *ngIf="!shouldHideField('openingDate')">
							<span>{{ labels.lbl_chamado_data_abertura }}</span>
							<input type="text" disabled [value]="dateService.formatDate(requestData.open_date)" />
						</div>
						<div *ngIf="!shouldHideField('deadline')">
							<span>{{ labels.lbl_data_limite }}</span>
							<input type="text" disabled [value]="dateService.formatDate(requestData.limit_date)" />
						</div>
						<div *ngIf="!shouldHideField('classificationDate')">
							<span>{{ labels.lbl_chamado_data_classificacao }}</span>
							<input
								type="text"
								disabled
								[value]="
									requestData.classification_date ? dateService.formatDate(requestData.classification_date) : 'N/A'
								" />
						</div>

						<div class="dotted-input-container-change mt-2">
							<span>{{ labels.lbl_geral_tempo_total_mudanca }}</span>
							<div class="content-change-input">
								<div>{{ labels.lbl_chamado_data_inicio_acordada }}</div>
								<input
									type="date"
									[(ngModel)]="changePlanDates.startDateAgreed"
									[ngClass]="{ 'invalid-input': validationErrors['start_date'] }" />
								<input
									type="time"
									[(ngModel)]="changePlanDates.startTimeAgreed"
									[ngClass]="{ 'invalid-input': validationErrors['start_date'] }" />
							</div>
							<div class="content-change-input">
								<div>{{ labels.lbl_chamado_data_acordada }}</div>
								<input type="date" [(ngModel)]="changePlanDates.endDateAgreed" />
								<input type="time" [(ngModel)]="changePlanDates.endTimeAgreed" />
							</div>
						</div>

						<div class="dotted-input-container-change">
							<span>{{ labels.lbl_geral_execucao_change }}</span>
							<div class="content-change-input">
								<input
									type="date"
									[(ngModel)]="changePlanDates.execStartDate"
									[ngClass]="{ 'invalid-input': validationErrors['execution_start_date'] }" />
								<input
									type="time"
									[(ngModel)]="changePlanDates.execStartTime"
									[ngClass]="{ 'invalid-input': validationErrors['execution_start_date'] }" />
							</div>
							<div class="content-change-input">
								<input
									type="date"
									[(ngModel)]="changePlanDates.execEndDate"
									[ngClass]="{ 'invalid-input': validationErrors['execution_end_date'] }" />
								<input
									type="time"
									[(ngModel)]="changePlanDates.execEndTime"
									[ngClass]="{ 'invalid-input': validationErrors['execution_end_date'] }" />
							</div>
						</div>

						<div class="dotted-input-container-change">
							<span>{{ labels.lbl_geral_indisponibilidade }}</span>
							<div class="content-change-input">
								<input
									type="date"
									[(ngModel)]="changePlanDates.unavailabilityStartDate"
									[ngClass]="{ 'invalid-input': validationErrors['unavailability_start_date'] }" />
								<input
									type="time"
									[(ngModel)]="changePlanDates.unavailabilityStartTime"
									[ngClass]="{ 'invalid-input': validationErrors['unavailability_start_date'] }" />
							</div>
							<div class="content-change-input">
								<input
									type="date"
									[(ngModel)]="changePlanDates.unavailabilityEndDate"
									[ngClass]="{ 'invalid-input': validationErrors['unavailability_end_date'] }" />
								<input
									type="time"
									[(ngModel)]="changePlanDates.unavailabilityEndTime"
									[ngClass]="{ 'invalid-input': validationErrors['unavailability_end_date'] }" />
							</div>
						</div>
					</div>
					<div class="button-container mt-2" *ngIf="this.userView === userViewTypes.ANALYST">
						<div class="button" (click)="updateChangePlanDates()">{{ labels.lbl_geral_atualizar }}</div>
						<div class="button" (click)="resetChangePlanDates()">{{ labels.lbl_geral_limpar_campos }}</div>
						<div class="button" (click)="getChangePlanDates()">{{ labels.lbl_geral_location_limpar_campos }}</div>
					</div>
				</ng-container>

				<ng-container *ngIf="!isCustomfieldLoading && customfields && customfields.length > 0">
					<div class="content-col-header active no-collapse" #customfieldCollapsable>
						<span>{{ labels.lbl_geral_campos_customizados }}</span>
					</div>
					<div class="content-col static customfields">
						<pcp-request-customfield
							#requestCustomfieldComponent
							[setCustomfields]="customfields"
							[disabled]="
								isClassificationLoading == true ||
								(!isRequestBeingEdited &&
									!(
										userView === userViewTypes.ENDUSER &&
										ProfileService.userData().fullName == this.requestData.enduser &&
										this.requestData.status === 'Waiting User'
									))
							"
							(customfields)="customfields = $event"
							(isCustomfieldFulfilled)="_isCustomfieldFulfilled = $event">
						</pcp-request-customfield>

						<div
							class="button-container"
							*ngIf="
								userView === userViewTypes.ENDUSER &&
								ProfileService.userData().fullName == this.requestData.enduser &&
								this.requestData.status === 'Waiting User'
							">
							<div
								class="button"
								[ngClass]="{ disabled: !isClassificationFulfilled || isSavingLoading }"
								(click)="saveRequestChanges()">
								{{ labels.lbl_geral_atualizar }}
								<cpi-dot-bounce-loading-effect
									[color]="'var(--const-white)'"
									*ngIf="isSavingLoading"></cpi-dot-bounce-loading-effect>
							</div>
						</div>
					</div>
				</ng-container>

				<div class="mt-2" *ngIf="isCustomfieldLoading">
					<cpi-dot-bounce-loading-effect [color]="'var(--gray-5)'"></cpi-dot-bounce-loading-effect>
				</div>

				<div
					class="content-col-header clickable"
					(click)="collapseContent(customerCollapsable)"
					#customerCollapsable
					id="classificationCollapsable">
					<span>{{ labels.lbl_geral_cliente }} - {{ requestData.customer }}</span>
					<span><fa-icon [icon]="icons.faAngleDown"></fa-icon></span>
				</div>
				<div class="content-col collapsable">
					<div *ngIf="!shouldHideField('customer')">
						<span>{{ labels.lbl_geral_cliente }}</span> <input type="text" disabled [value]="requestData.customer" />
					</div>
					<div *ngIf="!shouldHideField('site')">
						<span>{{ labels.lbl_geral_site }}</span> <input type="text" disabled [value]="requestData.site" />
					</div>
					<div *ngIf="!shouldHideField('department')">
						<span>{{ labels.lbl_geral_depto }}</span> <input type="text" disabled [value]="requestData.department" />
					</div>
				</div>

				<div
					class="content-col-header clickable"
					(click)="collapseContent(analystInfoCollapsable)"
					#analystInfoCollapsable
					id="analystInfoCollapsalble"
					*ngIf="userView === userViewTypes.ANALYST && changeAnalystToDriver === false">
					<span
						>{{ labels.lbl_geral_info_analista }}
						<ng-container *ngIf="requestData.id_analyst"> - {{ requestData.analyst }}</ng-container></span
					>
					<span><fa-icon [icon]="icons.faAngleDown"></fa-icon></span>
				</div>
				<div class="content-col collapsable" *ngIf="userView === userViewTypes.ANALYST && changeAnalystToDriver === false">
					<ng-container *ngIf="!isRequestBeingEdited">
						<div *ngIf="!shouldHideField('analyst')">
							<span>{{ labels.lbl_geral_analista }}</span> <input type="text" disabled [value]="requestData.analyst" />
						</div>
						<div *ngIf="!shouldHideField('email')">
							<span>{{ labels.lbl_geral_email }}</span> <input type="text" disabled [value]="requestData.email_analyst" />
						</div>

						<ng-container *ngIf="requestData.contacts_analyst && requestData.contacts_analyst.length > 0">
							<div class="header">+ {{ labels.lbl_geral_comunicacao }}</div>
							<div *ngFor="let contacts of requestData.contacts_analyst" (click)="redirectToContact(contacts)">
								<span>{{
									contacts.contact_type === 'WPP' ? 'Whatsapp' : contacts.contact_type === 'TEAMS' ? 'Teams' : ''
								}}</span>
								<input class="contact-link" type="text" disabled [value]="contacts.contact_value" />
							</div>
						</ng-container>
					</ng-container>

					<ng-container *ngIf="isRequestBeingEdited && changeAnalystToDriver === false">
						<div>
							<span>{{ labels.lbl_geral_analista }}</span>
							<select (change)="requestData.id_analyst = $event.target.value">
								<option [value]="'-1'">{{ labels.lbl_geral_selecione }}</option>
								<option
									[value]="analyst.id"
									[selected]="analyst.id == requestData.id_analyst"
									*ngFor="let analyst of availableAnalysts">
									{{ analyst.fullName }}
								</option>
							</select>
						</div>
					</ng-container>
				</div>

				<div class="content-col-header clickable" (click)="collapseContent(userInfoCollapsable)" #userInfoCollapsable>
					<span>{{ labels.lbl_geral_info_usuario }} - {{ requestData.enduser }}</span>
					<span><fa-icon [icon]="icons.faAngleDown"></fa-icon></span>
				</div>
				<div class="content-col collapsable mb-3">
					<div *ngIf="!shouldHideField('enduser')">
						<span>{{ labels.lbl_geral_usuario }}</span> <input type="text" disabled [value]="requestData.enduser" />
					</div>
					<div *ngIf="!shouldHideField('email')">
						<span>{{ labels.lbl_geral_email }}</span> <input type="text" disabled [value]="requestData.email_enduser" />
					</div>
					<div *ngIf="!shouldHideField('telephone')">
						<span>{{ labels.lbl_geral_telefone }}</span>
						<input type="text" disabled [value]="requestData.phone_enduser ? requestData.phone_enduser : ''" />
					</div>
					<div *ngIf="requestData.relatedEnduser && !shouldHideField('affectedUser')">
						<span>{{ labels.lbl_geral_usuario_relacionado }}</span>
						<input type="text" disabled [value]="requestData.relatedEnduser" />
					</div>
				</div>

				<pcp-search-information class="mb-3" [labels]="labels"></pcp-search-information>
			</div>
		</div>

		<div
			class="folder-container"
			[ngClass]="{ showOnSmall: isTabContentContainerFixed }"
			[ngStyle]="{ width: ghostResizeBar.tabContentWidth + '%' }">
			<div class="tab-container">
				<span class="tab" [ngClass]="{ selected: actualTab === tabs[0].changeTab }" (click)="actualTab = tabs[0].changeTab">
					{{ tabs[0].tabName }}
				</span>
				<span class="tab" [ngClass]="{ selected: actualTab === tabs[1].changeTab }" (click)="actualTab = tabs[1].changeTab">
					{{ tabs[1].tabName }}
				</span>
				@if (tabs && tabs.length > 1) {
					<span
						class="tab"
						[ngClass]="{
							selected: actualTab !== tabs[0].changeTab && actualTab !== tabs[1].changeTab && actualTab !== tabs[2].changeTab,
						}"
						(click)="actualTab = tabs[2].changeTab"
						>{{ tabs[2].tabName }}</span
					>
				}
				<span class="tab smallOnly" (click)="isTabContentContainerFixed = false">{{ labels.lbl_geral_fechar }}</span>
			</div>

			@if (actualTab === 'Acompanhamento') {
				<div class="tab-data-container">
					<div class="log-container">
						<div class="log-scroll-container" (mouseleave)="isSecondaryLogButtonOpen = false">
							<div class="log-scroll-button-container">
								<div
									class="button"
									[ngClass]="{ 'double-button': userView !== userViewTypes.ENDUSER }"
									(click)="logModal.openModal()">
									{{ labels.lbl_incluir_acompanhamento }}
								</div>
								@if (userView !== userViewTypes.ENDUSER) {
									<div (click)="isSecondaryLogButtonOpen = !isSecondaryLogButtonOpen">
										<fa-icon
											[ngClass]="{ 'rotate-180': isSecondaryLogButtonOpen }"
											[icon]="icons.faAngleDown"></fa-icon>
									</div>
								}
							</div>
							@if (isSecondaryLogButtonOpen && userView !== userViewTypes.ENDUSER) {
								<div class="log-scroll-secondary-button-container">
									@for (status of availableStatus; track $index) {
										<span (click)="sendEmailEnduser = false; newLog.status = status.status; logModal.openModal()">
											{{ labels.lbl_atualizar_para }}: "{{ status.label }}"
										</span>
									}
								</div>
							}

							@if (!requestData.logs || requestData.logs.length === 0) {
								<div class="log">
									{{ labels.lbl_chamado_sem_logs }}
								</div>
							}
							@for (log of requestData.logs; track $index) {
								<div
									class="log"
									[ngClass]="{
										'super-user-edit': isSuperEditingLog,
										'super-user-edit-clickable': isSuperEditingLog,
										'super-selected': newSuperLog.idLog === log.idLog,
									}"
									(click)="isSuperEditingLog && newSuperLog.idLog !== log.idLog ? setNewSuperLog(log) : null">
									@if (newSuperLog.idLog === '' || newSuperLog.idLog !== log.idLog) {
										<span class="log-date"
											>{{ dateService.formatDate(log.log_date) }} -
											{{ allStatusAsLabel[log.status] ? allStatusAsLabel[log.status] : log.status }}</span
										>
										<span class="log-date">{{ log.analyst }}</span>
										@if (
											log.notes !== '' &&
											log.duration !== '00:00' &&
											!permissionService.hasPermission('REQUEST_hide_duration')
										) {
											<span class="log-date">{{ labels.lbl_geral_duracao }}: {{ formatDuration(log.duration) }}</span>
										}
										@for (file of log.file_log; track $index) {
											<span class="log-file" (click)="file.file_path !== '...' ? downloadFile(file.file_path) : null">
												<fa-icon class="mr-1" [icon]="icons.faDownload"></fa-icon>
												{{ formatAttachPath(file.file_path) }}
											</span>
										}
										<div class="log-notes">
											@if (getLogPrimaryNotes(log.notes)) {
												<div [innerHTML]="getLogPrimaryNotes(log.notes) | deNLize"></div>
											}
											@if (getLogInfoNote(log.notes)) {
												<cpi-info-alert
													[message]="getLogInfoNote(log.notes) | deNLize"
													[compact]="true"
													[useHtml]="true">
												</cpi-info-alert>
											}
										</div>
									}

									@if (newSuperLog.idLog === log.idLog) {
										<span class="log-date mb-2">
											<input
												type="date"
												[value]="formatDateToValue(log.log_date)"
												(change)="newSuperLog.log_date = $any($event.target).value" />
										</span>
										<span class="log-date mb-2">
											<select (change)="newSuperLog.status = $any($event.target).value">
												@for (status of availableStatus; track $index) {
													<option [value]="status.status" [selected]="newSuperLog.status === status.status">
														{{ status.label }}
													</option>
												}
											</select>
										</span>
										<span class="log-date mb-2"
											><input
												type="text"
												[placeholder]="labels.lbl_analista"
												(input)="newSuperLog.analyst = $any($event.target).value"
												[value]="log.analyst"
										/></span>
										<span class="log-date mb-2"
											><input
												type="text"
												matInput
												mask="Hh:m0"
												(input)="newSuperLog.duration = $any($event.target).value"
												[value]="formatDuration(log.duration)"
										/></span>
										<span class="log-notes">
											<textarea
												rows="3"
												(input)="newSuperLog.notes = $any($event.target).value"
												[value]="log.notes | deNLize"></textarea>
										</span>

										<div class="button-container">
											<div class="button" (click)="resetSuperLog(); isSuperEditingLog = false">
												{{ labels.lbl_geral_cancelar }}
											</div>
											<div class="button" (click)="superUpdateLog(log.idLog)">{{ labels.lbl_geral_atualizar }}</div>
										</div>
									}
								</div>
							}
						</div>
					</div>
				</div>
			}

			@if (actualTab === 'Historico') {
				<pcp-request-page-tab-solution-area-history [requestData]="requestData"></pcp-request-page-tab-solution-area-history>
			}

			@if (actualTab === 'Tasks') {
				<div class="tab-data-container">
					<div class="task-scroll-container loading-container-task" *ngIf="isUpdatingTask">
						<cpi-svg-gears></cpi-svg-gears>
						<div>{{ labels.lbl_edocs_carregando }}!</div>
					</div>
					<div class="task-scroll-container" *ngIf="!isUpdatingTask">
						<div class="task" *ngIf="!requestData.tasks || requestData.tasks.length === 0">
							{{ labels.lbl_no_tasks }}
						</div>
						<div *ngIf="!isLoadingTask">
							<div class="task" *ngFor="let task of requestData.tasks; let taskIndex = index">
								<span
									class="link"
									(click)="
										NotificationService.setNotificationMessage(
											labels.lbl_rejeitar_esta_tarefa_retornara_para_as_tarefas + ' ' + task.predecessor
										)
									"
									[title]="labels.lbl_rejeitar_esta_tarefa_retornara_para_as_tarefas + ' ' + task.predecessor"
									*ngIf="
										(task.task_status === 'Pending' || task.task_status === 'In Progress') &&
										(task.task_type === 'Authorization' || task.task_type === 'Review')
									"
									><fa-icon [icon]="icons.faExclamationCircle"></fa-icon> {{ labels.lbl_geral_predecessores }}</span
								>
								<div class="header">
									<span>{{ task.task_order_number }} - {{ task.task_name }}</span>
									<span
										class="status-markdown"
										[ngClass]="{
											green:
												task.task_status === 'Executed' ||
												task.task_status === 'Accepted' ||
												task.task_status === 'Approved',
											yellow: task.task_status === 'Pending' || task.task_status === 'In Progress',
											red: task.task_status === 'Rejected',
										}">
										{{ task.task_status }}
									</span>
								</div>
								<div class="task-header-id">
									<span>ID: {{ task.id_task }}</span>
									<span
										class="delete-trash"
										#customTaskTrashIcon
										*ngIf="
											task.custom_task == '1' &&
											task.task_status !== 'Executed' &&
											task.task_status !== 'Skipped' &&
											((task.task_type === 'Execution - SubRequest' && task.task_status !== 'In Progress') ||
												task.task_type === 'Execution')
										"
										(click)="
											customTaskTrashIcon.classList.contains('confirmClick')
												? deleteCustomTask(task)
												: confirmButton(customTaskTrashIcon)
										"
										><fa-icon [icon]="icons.faTrash"></fa-icon
									></span>
								</div>

								<span *ngIf="task.limit_date !== ''"
									>{{ labels.lbl_geral_data_limite2 }}: {{ dateService.formatDate(task.limit_date) }}</span
								>
								<span *ngIf="task.subrequest_id === ''">{{ labels.lbl_geral_descricao }}:</span>

								<span *ngIf="task.subrequest_id === ''">
									<textarea
										[value]="task.task_description | deNLize"
										[rows]="3"
										[disabled]="
											(task.task_status !== 'Pending' && task.task_status !== 'In Progress') ||
											!task.show_buttons ||
											task.show_buttons === '' ||
											isUpdatingTask
										"
										(input)="newTask.task_description = $event.target.value"></textarea>
								</span>

								<ng-container *ngIf="taskCustomFields && taskCustomFields.length > 0 && !isTaskCustomFieldLoading">
									<div class="content-col static taskcustomfields">
										<ng-container *ngFor="let field of taskCustomFields">
											<div *ngIf="field.idRequestTask == task.id_task">
												<div *ngIf="field.typeTaskCustomField === 'text'" class="dotted-input-container">
													<span
														>{{ field.nameTaskCustomField
														}}{{ field.requiredTaskCustomField == 1 ? ' *' : '' }}</span
													>
													<input
														type="text"
														[(ngModel)]="field.requestValueTaskCustomField"
														(ngModelChange)="clearTaskCustomFieldAlert(field)"
														[ngClass]="{ 'required-alert': field.alertTaskCustomField === true }"
														[disabled]="
															(task.task_status !== 'Pending' && task.task_status !== 'In Progress') ||
															!task.show_buttons ||
															task.show_buttons === '' ||
															isUpdatingTask
														" />
												</div>

												<div *ngIf="field.typeTaskCustomField === 'select'" class="dotted-input-container">
													<span
														>{{ field.nameTaskCustomField
														}}{{ field.requiredTaskCustomField == 1 ? ' *' : '' }}</span
													>
													<select
														[(ngModel)]="field.requestValueTaskCustomField"
														(ngModelChange)="clearTaskCustomFieldAlert(field)"
														[ngClass]="{ 'required-alert': field.alertTaskCustomField === true }"
														[disabled]="
															(task.task_status !== 'Pending' && task.task_status !== 'In Progress') ||
															!task.show_buttons ||
															task.show_buttons === '' ||
															isUpdatingTask
														">
														<option
															*ngFor="let option of field.valuesTaskCustomField"
															[value]="option.valueItemTaskCustomField">
															{{ option.textItemTaskCustomField }}
														</option>
													</select>
												</div>
											</div>
										</ng-container>
									</div>
								</ng-container>

								<ng-container
									*ngIf="
										(task.task_type === 'Authorization' || task.task_type === 'Review') &&
										(task.task_status === 'Pending' || task.task_status === 'In Progress') &&
										task.subrequest_id === ''
									">
									<ng-container>
										<div class="mb-2" *ngIf="task.disableApproverControls">
											<cpi-generic-form-gen [setGenericForm]="task.taskApproverFormItem" [boldLabel]="false">
											</cpi-generic-form-gen>
										</div>
										<div *ngIf="task.already_approved_analysts.length > 0">
											<span>{{ labels.lbl_geral_usuarios_aprovaram }}</span>
											<span class="tip">
												<ng-container *ngFor="let analyst of task.already_approved_analysts; let last = last">
													{{ analyst.email }}<ng-container *ngIf="!last">, </ng-container>
												</ng-container>
											</span>
										</div>
										<div class="button-container mb-2" *ngIf="task.disableApproverControls">
											<div
												class="button"
												[ngClass]="{ disabled: isUpdatingTask }"
												(click)="updateTaskApprover(taskIndex)">
												{{ labels.lbl_atualizar_aprovadores }}
											</div>
										</div>
										<div *ngIf="!task.disableApproverControls" class="mb-2">
											<span class="tip">
												{{
													labels.lbl_aprovadores_definidos_campo_customizado +
														':' +
														' ' +
														getApproverCustomFieldNameForTask(task.id_task)
												}}
											</span>
										</div>
										<div class="button-container mb-2">
											<div class="button" *ngIf="canResendEmail()" (click)="resendTaskApprovalEmail(taskIndex)">
												Reenviar e-mail
											</div>
										</div>
									</ng-container>
									<ng-container *ngIf="task.connector === 'AND'">
										<ng-container *ngIf="task.approvedList.length > 0">
											<ng-container *ngFor="let approver of task.approvedList; let approverI = index">
												{{ approver
												}}<ng-container *ngIf="approverI != task.approvedList.length - 1">, </ng-container>
											</ng-container>
											{{ labels.lbl_geral_aprovaram }}.
										</ng-container>
										<ng-container *ngIf="task.remainingApproveList.length > 0">
											<ng-container *ngFor="let approver of task.remainingApproveList; let approverI = index">
												{{ approver
												}}<ng-container *ngIf="approverI != task.remainingApproveList.length - 1">, </ng-container>
											</ng-container>
											{{ labels.lbl_ainda_pendente_aprovacao }}.
										</ng-container>
									</ng-container>
								</ng-container>

								<div
									*ngIf="
										task.task_type === 'Execution' &&
										(task.task_status === 'Pending' || task.task_status === 'In Progress') &&
										task.show_buttons &&
										task.show_buttons !== '' &&
										task.subrequest_id === ''
									">
									<div class="dotted-input-container">
										<span>{{ labels.lbl_geral_grupo }}*</span>
										<select
											[(ngModel)]="task.task_id_solution_area"
											(change)="getSolutionAreaAnalysts(task.task_id_solution_area, taskIndex)">
											<option [value]="'-1'">{{ labels.lbl_geral_selecione }}</option>
											<option *ngFor="let solutionArea of solutionAreas" [value]="solutionArea.id">
												{{ solutionArea.solutionArea }}
											</option>
										</select>
									</div>
									<div class="dotted-input-container">
										<span>{{ labels.lbl_geral_analista }}*</span>
										<select (change)="task.task_analyst = $event.target.value">
											<option [value]="'-1'">{{ labels.lbl_geral_selecione }}</option>
											<option
												*ngFor="let taskAnalyst of task.available_task_analysts"
												[value]="taskAnalyst.id"
												[selected]="taskAnalyst.id == task.task_analyst">
												{{ taskAnalyst.full_name }}
											</option>
										</select>
									</div>
								</div>

								<ng-container
									*ngIf="
										(task.task_status === 'Pending' ||
											task.task_status === 'In Progress' ||
											task.subrequest_id !== '') &&
										task.show_buttons &&
										task.show_buttons !== '' &&
										isUserInRemainingApproveList
									">
									<div class="file-button-container" *ngIf="task.subrequest_id === ''">
										<span [title]="allowedMimeTypeTip"><fa-icon [icon]="icons.faQuestionCircle"></fa-icon></span>
										<label class="button" for="taskFile{{ taskIndex }}">{{ labels.lbl_geral_anexar_arquivo }}</label>
										<input
											type="file"
											id="taskFile{{ taskIndex }}"
											#taskFile
											(change)="handleFileTask(taskIndex, taskFile)"
											[multiple]="true"
											[accept]="allowedMimeTypeStr" />
									</div>

									<div class="label" *ngIf="task.attachment.length > 0">{{ labels.lbl_geral_anexo }}</div>
									<div class="file-container">
										<div class="dotted-input-container" *ngFor="let file of task.attachment; let index = index">
											<span>{{
												file.file_path === '...'
													? file.name + '.' + file.extension
													: formatAttachPath(file.file_path)
											}}</span>
											<div class="icon-container">
												<span (click)="handleFileTask(taskIndex, null, index)"
													><fa-icon [icon]="icons.faTrash"></fa-icon
												></span>
												<span (click)="downloadFile(file.file_path)" *ngIf="file.file_path !== '...'"
													><fa-icon [icon]="icons.faDownload"></fa-icon
												></span>
											</div>
										</div>
									</div>

									<div
										class="button-container"
										*ngIf="
											task.subrequest_id === '' &&
											task.show_buttons &&
											task.show_buttons !== '' &&
											isUserInRemainingApproveList
										">
										<span
											class="button"
											[ngClass]="{ disabled: isUpdatingTask }"
											(click)="!isUpdatingTask ? updateTask(task.id_task, taskIndex, task_status.value) : null"
											*ngFor="let task_status of task.task_available_status"
											#taskStatus>
											{{ labels[task_status.label] ? labels[task_status.label] : task_status.label }}
										</span>
									</div>
									<div class="button-container">
										<ng-container *ngIf="task.subrequest_id !== '' && task.show_buttons && task.show_buttons !== ''">
											<div class="button">
												<span
													*ngIf="task.subrequest_id; else createRequestButton"
													(click)="openChildRequestPage(task.subrequest_id)">
													{{ labels.lbl_chamado_relacionado }}
												</span>
											</div>
											<ng-template #createRequestButton>
												<span class="button" (click)="createRequestFromTask(task.id_task)">
													{{ labels.lbl_abrir_chamado_relacionado_tarefa }}
												</span>
											</ng-template>
										</ng-container>
									</div>
								</ng-container>
							</div>
							<div class="custom-task-container">
								<div *ngFor="let task of newCustomTask; let i = index" class="multi-custom-task-container">
									<form>
										<div class="header">
											<span
												><strong>{{ labels.lbl_nova_tarefa }}</strong></span
											>
											<span
												class="delete-trash"
												#creatingCustomTaskTrashIcon
												(click)="
													creatingCustomTaskTrashIcon.classList.contains('confirmClick')
														? removeCreatingCustomTask(i)
														: confirmButton(creatingCustomTaskTrashIcon)
												"
												><fa-icon [icon]="icons.faTrash"></fa-icon
											></span>
										</div>
										<div class="dotted-input-container">
											<span>{{ labels.lbl_id_tarefa }}*</span>
											<input
												type="number"
												[(ngModel)]="task.taskId"
												name="taskId{{ i }}"
												placeholder="{{ labels.lbl_id_tarefa }}" />
										</div>

										<div class="dotted-input-container">
											<span>{{ labels.lbl_chamado_tarefa }}*</span>
											<input
												type="text"
												[(ngModel)]="task.task"
												name="task{{ i }}"
												placeholder="{{ labels.lbl_chamado_tarefa }}" />
										</div>

										<div class="dotted-input-container">
											<span class="label">
												<span>{{ labels.lbl_geral_predecessores }}*</span>
												<span class="label-tip" [title]="labels.lbl_geral_predecessor_id_exemplo"
													><fa-icon [icon]="icons.faQuestionCircle"></fa-icon
												></span>
											</span>
											<input
												type="text"
												[(ngModel)]="task.predecessor"
												name="task{{ i }}"
												placeholder="{{ labels.lbl_geral_predecessores }}" />
										</div>

										<div class="dotted-input-container">
											<span>{{ labels.lbl_geral_tipo }}*</span>
											<select [(ngModel)]="task.type" name="type{{ i }}">
												<option value="" [selected]="!task.type">{{ labels.lbl_geral_selecione }}</option>
												<option value="Execution">Execution</option>
												<option value="Execution - SubRequest">Execution - SubRequest</option>
											</select>
										</div>

										<div class="dotted-input-container">
											<span>{{ labels.lbl_geral_grupo }}*</span>
											<select
												[(ngModel)]="task.solutionArea"
												name="solutionArea{{ i }}"
												(change)="onSolutionAreaChange(task, i)">
												<option value="" [selected]="!task.solutionArea">{{ labels.lbl_geral_selecione }}</option>
												<option *ngFor="let solutionArea of solutionAreas" [value]="solutionArea.id">
													{{ solutionArea.solutionArea }}
												</option>
											</select>
										</div>

										<div class="dotted-input-container">
											<span>{{ labels.lbl_geral_analista }}</span>
											<select [(ngModel)]="task.analyst" name="analyst{{ i }}">
												<option value="0" [selected]="!task.analyst">{{ labels.lbl_geral_selecione }}</option>
												<option *ngFor="let analyst of task.analysts" [value]="analyst.id">
													{{ analyst.full_name }}
												</option>
											</select>
										</div>

										<div class="dotted-input-container">
											<span>{{ labels.lbl_anexo_obrigatorio }}</span>
											<cpi-checkbox
												[value]="task.uploadRequired"
												(oValue)="task.uploadRequired = $event"
												[innerText]="task.uploadRequired == 1 ? labels.lbl_geral_sim : labels.lbl_geral_nao">
											</cpi-checkbox>
										</div>
									</form>
								</div>
								<div class="button-container button-margin">
									<div class="button" *ngIf="!(requestData.status === 'Solved')" (click)="addCustomTaskForm()">
										{{ labels.lbl_adicionar_tarefa }}
									</div>
									<div class="button" (click)="clearAllCustomTask()" *ngIf="creatingCustomTask">
										{{ labels.lbl_geral_cancelar }}
									</div>
									<div class="button" (click)="postCustomTask()" *ngIf="creatingCustomTask">
										{{ labels.lbl_geral_salvar }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			}

			@if (actualTab === 'CI') {
				<pcp-request-page-tab-related-ci
					[requestData]="requestData"
					[requestDataMemory]="requestDataMemory"
					(requestDataChange)="requestData = $event; saveRequestChanges()">
				</pcp-request-page-tab-related-ci>
			}

			@if (actualTab === 'inconsistency') {
				<pcp-request-page-tab-inconsistency [requestData]="requestData"></pcp-request-page-tab-inconsistency>
			}

			@if (actualTab === 'Change') {
				<div class="change-container">
					<div class="change-scroll-container">
						<div class="change" *ngFor="let change of requestData.changePlan">
							<pcp-request-page-tab-change-plan [idRequest]="requestData.id"> </pcp-request-page-tab-change-plan>
						</div>
					</div>
				</div>
			}

			@if (actualTab === 'relatedArticles') {
				<pcp-request-page-tab-related-kb [requestData]="requestData"></pcp-request-page-tab-related-kb>
			}

			@if (actualTab === 'attachments') {
				<pcp-request-page-tab-attachments [requestData]="requestData"></pcp-request-page-tab-attachments>
			}

			@if (actualTab === 'relatedRequests') {
				<pcp-request-page-tab-related-request [requestData]="requestData"></pcp-request-page-tab-related-request>
			}

			@if (actualTab === 'extraOptions') {
				<pcp-request-page-tab-extra-options [requestData]="requestData" [customfields]="customfields">
				</pcp-request-page-tab-extra-options>
			}

			@if (actualTab === 'crisisTeam' && requestData.high_severity == true) {
				<div class="crisis-team-container">
					<div class="crisis-team-scroll-container">
						<ng-container *ngIf="!isLoadingCrisisTeamForm">
							<span class="label">{{ labels.lbl_time_de_crise }}</span>

							<cpi-generic-form-gen [setGenericForm]="crisisTeamForm"> </cpi-generic-form-gen>

							<div class="button-container">
								<div class="button" [ngClass]="{ disabled: isLoadingCrisisTeam }" (click)="updateCrisisTeam()">
									{{ labels.lbl_geral_atualizar }}
									<cpi-dot-bounce-loading-effect
										[color]="'var(--const-white)'"
										*ngIf="isLoadingCrisisTeam"></cpi-dot-bounce-loading-effect>
								</div>
							</div>
						</ng-container>

						<cpi-dot-bounce-loading-effect
							[color]="'var(--primary-color-1)'"
							*ngIf="isLoadingCrisisTeamForm"></cpi-dot-bounce-loading-effect>
					</div>
				</div>
			}

			@if (actualTab === 'Plus') {
				<div class="tab-data-container">
					@for (tab of tabs; let index = $index; track tab) {
						<div class="plus-options-container">
							@if (index !== 0 && index !== 1 && index !== 2) {
								<div
									class="tab"
									[ngClass]="{ selected: actualTab === tab.changeTab }"
									(click)="tab.onClick ? tab.onClick() : (actualTab = tab.changeTab)">
									{{ tab.tabName }}
								</div>
							}
						</div>
					}
				</div>
			}
			<div class="ghost-resize-bar" (mousedown)="ghostResizeBar.mouseDown = true"></div>
		</div>

		@if (ghostResizeBar.mouseDown) {
			<div class="ghost-screen" (mouseup)="ghostResizeBar.mouseDown = false" (mousemove)="handleGhostResizeBar($event)"></div>
		}
	</section>
</div>

<div class="openTabsOnSmall" *ngIf="isTabContentContainerFixed === false" (click)="isTabContentContainerFixed = true">
	{{ labels.lbl_abrir_abas }}
</div>

<cpi-modal
	[title]="labels.lbl_adicionar_nova_log"
	[showFooter]="true"
	(onModalClose)="logModal.closeModal()"
	(fullscreenChange)="isModalExpanded = $event"
	#logModal>
	<ng-container body>
		<div class="textarea-wrapper" [class.expanded]="isModalExpanded">
			<textarea
				[placeholder]="labels.lbl_escreva_informacoes_log"
				[rows]="3"
				[value]="newLog.notes"
				(input)="newLog.notes = $any($event.target).value"></textarea>
		</div>

		@if (userView === userViewTypes.ANALYST) {
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_status }}</span>
				@if (!isLoadingAvailableStatus) {
					<select (change)="newLog.status = $any($event.target).value">
						<option value="" disabled [selected]="!newLog.status">{{ labels.lbl_geral_selecione }}</option>
						@for (status of availableStatus; track $index) {
							<option [value]="status.status" [selected]="status.status === newLog.status || status.status === ''">
								{{ status.label }}
							</option>
						}
					</select>
				}
				@if (isLoadingAvailableStatus) {
					<cpi-dot-bounce-loading-effect [color]="'var(--gray-5)'"></cpi-dot-bounce-loading-effect>
				}
			</div>
		}

		@if (newLog.status === 'Waiting User' && userView === userViewTypes.ANALYST && threeStrikes > 1) {
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_aplicar_strike }}</span>
				<cpi-checkbox
					[value]="applyStrike"
					(oValue)="applyStrike = $event"
					[innerText]="applyStrike ? labels.lbl_geral_sim : labels.lbl_geral_nao">
				</cpi-checkbox>
			</div>
		}

		@if (newLog.status === 'Solved' && userView === userViewTypes.ANALYST && requestDataMemory.child_requests?.length > 0) {
			<div class="dotted-input-container">
				<span>{{ labels.lbl_encerrar_tambem_chamados_filho }}</span>
				<cpi-checkbox
					[value]="closeChildRequests"
					(oValue)="closeChildRequests = $event"
					[innerText]="closeChildRequests ? labels.lbl_geral_sim : labels.lbl_geral_nao">
				</cpi-checkbox>
			</div>
		}

		@if (newLog.status !== 'Internal Comment') {
			<div>
				<div class="dotted-input-container">
					<span>{{ userView === userViewTypes.ANALYST ? labels.lbl_chamado_enviar_email_solicitante : 'Enviar e-mail' }}</span>
					<cpi-checkbox
						[value]="sendEmailEnduser"
						(oValue)="sendEmailEnduser = $event"
						[innerText]="sendEmailEnduser ? labels.lbl_geral_sim : labels.lbl_geral_nao">
					</cpi-checkbox>
				</div>
			</div>
		}

		@if (newLog.status !== 'Internal Comment' && sendEmailEnduser) {
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_notificar_email_copia }}:</span>
				<input
					type="text"
					[value]="selectedEmailCCUserIAC.name"
					placeholder="Digite um ou mais e-mails separados por , ou ;"
					(input)="selectedEmailCCUserIAC.name = $any($event.target).value; selectedEmailCCUserIAC.value = ''" />
			</div>
		}

		@if (newLog.status !== 'Internal Comment' && userView === userViewTypes.ANALYST) {
			<div>
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_anexo_enduser }}</span>
					<cpi-checkbox
						[value]="newLog.sendEmailAttachEnduser"
						(oValue)="newLog.sendEmailAttachEnduser = $event"
						[innerText]="newLog.sendEmailAttachEnduser ? labels.lbl_geral_sim : labels.lbl_geral_nao">
					</cpi-checkbox>
				</div>
			</div>
		}

		@if (userView === userViewTypes.ANALYST) {
			<div class="dotted-input-container">
				<div>
					<span>{{ labels.lbl_geral_duracao }}</span>
					<span [title]="labels.lbl_request_duration_tip"><fa-icon [icon]="icons.faQuestionCircle"></fa-icon></span>
				</div>
				<div class="input-timer-container">
					<fa-icon [icon]="currentTimerIcon"></fa-icon>
					<input
						class="input-timer"
						mask="00:00"
						[placeholder]="newLog.duration"
						[value]="newLog.duration"
						(input)="newLog.duration = $any($event.target).value"
						(blur)="formatTimer()"
						[disabled]="startTimer === true" />
					<div class="button" (click)="countRequestDuration(newLog.duration)">
						{{ startTimer ? labels.lbl_geral_parar_cont : labels.lbl_geral_iniciar_cont }}
					</div>
				</div>
			</div>
		}

		@if (
			newLog.status === 'Solved' && requestData.service_type === 'Incident' && isLimitDateOver() && userView === userViewTypes.ANALYST
		) {
			<div class="label">{{ labels.lbl_geral_conformidade }}:</div>
			<textarea
				class="mt-1"
				[placeholder]="labels.lbl_motivo_atraso"
				[rows]="3"
				[value]="newLog.overdueReason"
				(input)="newLog.overdueReason = $any($event.target).value">
			</textarea>
		}

		<div class="dotted-input-container">
			<div>
				{{ labels.lbl_geral_anexar_arquivo }}
				<span [title]="allowedMimeTypeTip"><fa-icon [icon]="icons.faQuestionCircle"></fa-icon></span>
			</div>
			<div>
				<label class="button" for="logFile">{{ labels.lbl_geral_anexar_arquivo }}</label>
				<input type="file" id="logFile" #logFile (change)="handleFileLog()" [multiple]="true" [accept]="allowedMimeTypeStr" />
			</div>
		</div>

		@if (newLog.file_log.length > 0) {
			<div class="label" *ngIf="">{{ labels.lbl_geral_anexo }}</div>
		}
		<div class="file-container">
			@for (file of newLog.file_log; let index = $index; track file) {
				<div class="dotted-input-container">
					<span>{{ file.name }}.{{ file.extension }}</span>
					<span (click)="handleFileLog(index)">
						<fa-icon [icon]="icons.faTrash"></fa-icon>
					</span>
				</div>
			}
		</div>
	</ng-container>

	<ng-container footer>
		<div class="button-container">
			<button (click)="logModal.closeModal()">{{ labels.lbl_geral_fechar }}</button>
			<msp-button [disabled]="isSendingLog" [loading]="isSendingLog" (click)="addLog()">{{ labels.lbl_geral_enviar }}</msp-button>
		</div>
	</ng-container>
</cpi-modal>

<cpi-modal [title]="labels.lbl_geral_cancelar_chamado" #cancelRequestModal>
	<ng-container body>
		<span>{{ labels.lbl_deseja_cancelar_chamado }}</span>
		<textarea
			[placeholder]="labels.lbl_geral_motivo_cancelamento"
			[rows]="3"
			[value]="newLog.notes"
			(input)="newLog.notes = $event.target.value"></textarea>
		<div class="button-container">
			<button (click)="cancelRequestModal.closeModal()">{{ labels.lbl_geral_nao }}</button>
			<button class="danger" (click)="cancelRequest()">{{ labels.lbl_geral_sim }}</button>
		</div>
	</ng-container>
</cpi-modal>

<div
	class="loading-container"
	*ngIf="isRequestPageLoading || isAvailableCiLoading || isLoadingAllStatus || isLoadingAllowedMimeTypes || isLoadingAvailableTemplates">
	<cpi-svg-gears></cpi-svg-gears>
	<div>{{ labels.lbl_edocs_carregando }}!</div>
</div>
